import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_SYSTEM_SETTING,
  UPDATE_SYSTEM_SETTING,
  CLEAR_MESSAGE,
} from "./actionTypes"

const INIT_STATE = {
  settingData: [],
  error: {},
  message: "",
}

const Settings = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SYSTEM_SETTING:
          return {
            ...state,
            settingData: action.payload.data,
            isDetailsFetch: true,
          }

        case UPDATE_SYSTEM_SETTING:
          return {
            ...state,
            isSettingUpdated: true,
            message: "Successfully settings updated!",
            error: {},
          }

        default:
          return { ...state }
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_SYSTEM_SETTING:
          return {
            ...state,
            error: action.payload.error,
            isDetailsFetch: false,
          }

        case UPDATE_SYSTEM_SETTING:
          return {
            ...state,
            error: action.payload.error,
            isSettingUpdated: false,
          }

        default:
          return { ...state }
      }
    case GET_SYSTEM_SETTING:
      return {
        ...state,
        isDetailsFetch: true,
        isSettingUpdated: false,
      }

    case UPDATE_SYSTEM_SETTING:
      return {
        ...state,
        isSettingUpdated: false,
      }
    case CLEAR_MESSAGE:
      return {
        ...state,
        error: {},
        message: "",
      }

    default:
      return state
  }
}

export default Settings
